import { IStatus, IStatusFormPersistence, IStatusFormValues, IStatusLog, IStatusLogPersistence, IStatusMap, IStatusMapPersistence, IStatusPersistence } from '../interfaces';

export class StatusMapper {
  public static toDomain(status: IStatusPersistence): IStatus {
    return {
      id: status.id,
      name: status.name,
      nameEn: status.name_en,
      parentId: status.parent_id,
      model: {
        id: status.model_id,
        name: status.model_name,
      },
      createdAt: status.created_at,
      description: status.descr,
      freely: !!status.freely,
    };
  }
}

export class StatusLogMapper {
  public static toDomain(statusLog: IStatusLogPersistence): IStatusLog {
    return {
      id: statusLog.id,
      status: { id: statusLog.state_id, name: statusLog.state_name },
      user: { id: statusLog.user_id, name: statusLog.user_name },
      createdAt: statusLog.created_at,
    };
  }
}

export class StatusMapMapper {
  public static toDomain(status: IStatusMapPersistence): IStatusMap {
    return {
      id: status.id,
      descr: status.descr,
      createdAt: status.created_at,
      state: {
        id: status.state_id,
        name: status.state_name,
      },
      user: {
        id: status.user_id,
        name: status.user_name,
      },
    };
  }
}

export class CreateStatusMapper {
  public static toDomain(status: IStatus): IStatusFormValues {
    return {
      id: status.id.toString(),
      name: status.name,
      nameEn: status.nameEn,
      parentId: status.parentId?.toString() ?? '',
      modelId: status.model ? status.model.id.toString() : '',
      description: status.description,
    };
  }

  public static toPersistence(status: IStatusFormValues): IStatusFormPersistence {
    return {
      state_id: status.id,
      name: status.name,
      name_en: status.nameEn,
      parent_id: status.parentId,
      model_id: status.modelId,
      descr: status.description,
    };
  }
}

/** Server-side validation errors (snake_case) → Formik field errors. */
export class CreateStatusErrorsMapper {
  public static toDomain(errors: Record<string, string[]>): Record<string, string> {
    return {
      id: errors?.id?.join('. '),
      name: errors?.name?.join('. '),
      nameEn: errors?.name_en?.join('. '),
      parentId: errors?.parent_id?.join('. '),
      modelId: errors?.model_id?.join('. '),
      description: errors?.descr?.join('. '),
    } as Record<string, string>;
  }
}
